import { actions } from "@/store/modules/app"

export default class WS {
    constructor(onMessage, url, noReconnect = false, reconnectMaxTries = 5, reconnectWait = 100) {
        this.webSocket = null
        this.noReconnect = noReconnect
        this.reconnectCounter = 0
        this.reconnectMaxTries = reconnectMaxTries
        this.reconnectWait = reconnectWait
        this.onMessage = onMessage
        this.url = url
        this.openClosedCallbackUsed = false
    }

    close = () => {
        if (!this.webSocket) return
        this.noReconnect = true
        this.webSocket.close()
        this.webSocket = null
    }

    connect = (onOpen, onClose) => {
        const PROTOCOL = process.env.VUE_APP_WS_PROTOCOL ? process.env.VUE_APP_WS_PROTOCOL : "";
        const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
        const BASE_URL = `${PROTOCOL}://${HOST}`;

        if (this.webSocket) return
        this.webSocket = new WebSocket(BASE_URL + this.url);

        this.webSocket.onopen = () => {
            console.log("Import WebSocket: connected");
            this.reconnectCounter = 0;

            if (!this.openClosedCallbackUsed) {
                this.openClosedCallbackUsed = true

                if (onOpen) {
                    onOpen()
                }
            }
        };

        this.webSocket.onmessage = (ev) => {
            let data = JSON.parse(ev.data);

            this.onMessage(data)
        };

        this.webSocket.onclose = () => {
            if (!this.openClosedCallbackUsed) {
                this.openClosedCallbackUsed = true

                if (onClose) {
                    onClose()
                }
            }

            if(this.noReconnect){
                console.log("Import WebSocket: connection closed");
                this.noReconnect = false
                return
            }
            console.log("Import WebSocket: connection lost");
            if (this.reconnectCounter >= this.reconnectMaxTries) {
                actions.showGlobalConnectionLost();
            } else {
                this.reconnectCounter++;
            }
            setTimeout(() => {
                console.log("Import WebSocket: reconnecting...({0})".format(this.reconnectCounter));
                this.connect()
            }, this.reconnectWait);
        };
    }
}